import { getData, postData } from "../common/Apicall";

export const getOrdersBuyerSideApi = (page, buyerID, orderTitle) => {
  return postData(
    `/api/v1/orders/getOrderByBuyerID?page=${page}&orderTitle=${orderTitle}`,
    { buyerID }
  );
};

export const getOrdersSellerSideApi = (page, sellerID, orderTitle) => {
  return postData(
    `/api/v1/orders/getOrderBySellerID?page=${page}&orderTitle=${orderTitle}`,
    { sellerID }
  );
};

export const sellerOverviewApi = () => {
  return getData("/api/v1/orders/getSellerOverview");
};

export const sellerOrderOverviewApi = (month) => {
  return postData("/api/v1/orders/getSellerOrderOverview", { month });
};
export const getSellerOrderRevenue = (month) => {
  return postData("/api/v1/orders/getSellerOrderRevenue", { month });
};

export const createOrderApi = (
  buyerID,
  sellerID,
  productID,
  totalAmount,
  storeName,
  orderStatus,
  quantity,
  orderType
) => {
  return postData(`/api/v1/orders/addOrder`, {
    buyerID,
    sellerID,
    productID,
    totalAmount,
    storeName,
    orderStatus: null,
    quantity,
    orderType: "Pending",
    orderComments: null,
  });
};

export const toggleOrderStatusApi = (orderID, orderStatus) => {
  return postData(`/api/v1/orders/toggleOrderStatus`, { orderID, orderStatus });
};
